import { configureStore, createAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import logger from 'redux-logger';
import form from './formSlice';
import data from './dataSlice';
import notifications from './notificationsSlice';
import upload from './uploadSlice';
import user from './userSlice';

export const resetState = createAction('store/reset');

const reducer = combineReducers({
    form,
    data,
    notifications,
    upload,
    user
});

const reducerWrapper = (state, action) => {
    if (action.type === "store/reset") {
        return reducer({}, action);
    }
    return reducer(state, action);
};

export const store = configureStore({
    reducer: reducerWrapper,
    middleware: (getDefaultMiddleware) => process.env.NODE_ENV === "development" 
        ? getDefaultMiddleware().concat(logger)
        : getDefaultMiddleware()
});